import type { BillingPriceSummary } from './types'

const DEFAULT_PRICE_SUMMARY_CONFIG = {
  starter: { amountCents: 4900, currency: 'USD' },
  growth: { amountCents: 9900, currency: 'USD' },
  pro: { amountCents: 24_900, currency: 'USD' },
} as const

export function formatCurrency(args: {
  amount: number
  currency: string
}): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: args.currency.toUpperCase(),
    maximumFractionDigits: args.amount % 1 === 0 ? 0 : 2,
  }).format(args.amount)
}

export function emptyPriceSummary(): BillingPriceSummary {
  return {
    starter: null,
    growth: null,
    pro: null,
  }
}

export function defaultPriceSummary(): BillingPriceSummary {
  return {
    starter: {
      amount: DEFAULT_PRICE_SUMMARY_CONFIG.starter.amountCents / 100,
      amountCents: DEFAULT_PRICE_SUMMARY_CONFIG.starter.amountCents,
      currency: DEFAULT_PRICE_SUMMARY_CONFIG.starter.currency,
      label: formatCurrency({
        amount: DEFAULT_PRICE_SUMMARY_CONFIG.starter.amountCents / 100,
        currency: DEFAULT_PRICE_SUMMARY_CONFIG.starter.currency,
      }),
    },
    growth: {
      amount: DEFAULT_PRICE_SUMMARY_CONFIG.growth.amountCents / 100,
      amountCents: DEFAULT_PRICE_SUMMARY_CONFIG.growth.amountCents,
      currency: DEFAULT_PRICE_SUMMARY_CONFIG.growth.currency,
      label: formatCurrency({
        amount: DEFAULT_PRICE_SUMMARY_CONFIG.growth.amountCents / 100,
        currency: DEFAULT_PRICE_SUMMARY_CONFIG.growth.currency,
      }),
    },
    pro: {
      amount: DEFAULT_PRICE_SUMMARY_CONFIG.pro.amountCents / 100,
      amountCents: DEFAULT_PRICE_SUMMARY_CONFIG.pro.amountCents,
      currency: DEFAULT_PRICE_SUMMARY_CONFIG.pro.currency,
      label: formatCurrency({
        amount: DEFAULT_PRICE_SUMMARY_CONFIG.pro.amountCents / 100,
        currency: DEFAULT_PRICE_SUMMARY_CONFIG.pro.currency,
      }),
    },
  }
}
